
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/fonts/fonts.css';
import Modal from 'react-bootstrap/Modal';
import '../../assets/styles/modal.css';
import Arise4uBlackLogo from '../../assets/images/arise logo-01 1.svg';
import axios from 'axios';

const PayNowModal = ({ id, onClose, show = false, onSubmit, studentId }) => {
  const [loading, setLoading] = useState(false);

  const handlePayNow = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        "https://prodapi.ariseforyou.com/api/payment/initiate-payment",
        // "http://localhost:8000/api/payment/initiate-payment",
        // "https://devapi.ariseforyou.com/api/payment/initiate-payment",
        { studentId }
      );

      // Create a form dynamically
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = data.payuUrl;

      // Add payload fields to the form
      Object.keys(data.payload).forEach((key) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = data.payload[key];
        form.appendChild(input);
      });

      // Append form to document and submit
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Payment initiation failed:", error);
      alert("Failed to initiate payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <div className="logo-box">
          <img
            src={Arise4uBlackLogo}
            alt="Arise4u Black Logo"
            className="arise4u-black-logo"
          />
        </div>
        <button
          type="button"
          className="btn-close1 font-bold fs-5"
          onClick={onClose}
        >
          X
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="popup-qrcode-title-box mt-minus-60 d-flex flex-column justify-content-center align-items-center">

          <p className="font-bold text-center fs-2 mb-0 mt-20">
            Your learning journey is about to begin!<br />
            To unlock your learning experience, please
          </p>
          <p className="font-bold text-center fs-2 mb-0">
            Pay <span className="txt-blue">Rs. 2,990/- (incl GST)</span>
          </p>
        </div>
        <div className="popup-qrcode-btn-box d-flex flex-column justify-content-center align-items-center pt-3 pb-5">
          <div
            className="btn-design d-flex justify-content-center align-items-center cursor-pointer"
            onClick={handlePayNow}
            disabled={loading}
          >
            <p className="mb-0 txt-white font-regular-four fs-5 cursor-pointer">
              {loading ? "Processing..." : "Pay Now"}
            </p>
            <svg
              className="ms-2"
              width="20"
              height="20"
              data-name="Layer 1"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
            >
              <path d="M4.38 12.19 8.57 8 4.38 3.81l1.53-1.52L11.62 8l-5.71 5.71-1.53-1.52z" />
            </svg>
          </div>

          {/* New text below Pay Now button */}
          <p className='font-bold'
            style={{
              fontSize: "20px",
              textAlign: "center",
              marginTop: "10px",
              maxWidth: "650px",
              lineHeight: "1.4",
            }}
          >
            Convenience charges will apply on all payments done via Net Banking / Credit Card and other modes
            <br />
            <span className='font-bold fs-4 mb-0 mt-20'>UPI transfers / payments are free</span>
          </p>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default PayNowModal;